import classNames from 'classnames';
import { Select, SelectProps } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Alert, AlertSize, AlertType } from '../Alert/Alert';

import './SelectDecorator.css';

export interface SelectItem {
    val: string;
    text: string;
}

export type SelectDecoratorProps = SelectProps & {
    valid?: boolean;
    onClick?: () => void;
    errorText?: React.ReactNode;
};

const BLOCK = 'select-decorator';

export class SelectDecorator extends React.PureComponent<SelectDecoratorProps> {
    render() {
        const { cls, onClick, errorText, valid = true, ...passThroughProps } = this.props;

        return (
            <div
                className={classNames(
                    Bem.cls({
                        block: BLOCK,
                        mods: { valid: valid ? 'yes' : 'no' }
                    }),
                    cls
                )}
                onClick={onClick}
            >
                <Select {...passThroughProps} />
                {!valid && errorText && (
                    <div className={Bem.cls(BLOCK, 'validation-errors')}>
                        <Alert type={AlertType.error} size={AlertSize.s}>
                            {errorText}
                        </Alert>
                    </div>
                )}
            </div>
        );
    }
}
